import { Form, Modal } from 'react-bootstrap'
import style from './UploadConfigModal.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ChangeEvent, DragEvent, useState } from 'react'
import { hideModal } from '../../../store/actions/modalActions'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons/faFileInvoice'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { selectOneProductConfig } from '../../../store/selectors/configSelectors'
import { selectModalData } from '../../../store/selectors/modalSelectors'
import { uploadProductConfig } from '../../../store/async-thunks/products/uploadProductConfig'
import { UploadConfigDisclaimer } from './UploadConfigDisclaimer/UploadConfigDisclaimer'
import { UploadConfigHeader } from './UploadConfigHeader/UploadConfigHeader'
import { UploadFileDroppable } from './UploadFileDroppable/UploadFileDroppable'
import { UploadConfigFooter } from './UploadConfigFooter/UploadConfigFooter'

export const UploadConfigModal = () => {
    const dispatch = useAppDispatch()

    const [dragging, setDragging] = useState(false)
    const [selectedConfigName, setSelectedConfigName] = useState('')
    const [uploadedConfig, setUploadedConfig] = useState<File | undefined>(
        undefined
    )
    const modalData = useAppSelector(selectModalData)
    const { guid } = modalData
    const configuration = useAppSelector(selectOneProductConfig(guid))
    const configNames = Object.keys(configuration)

    const handleClose = (): void => {
        dispatch(hideModal())
    }

    const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
        event.preventDefault()
        setDragging(true)
    }

    const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault()
        setDragging(false)
    }

    const handleDrop = (e: DragEvent<HTMLDivElement>) => {
        e.preventDefault()
        setDragging(false)
        const configFile = e.dataTransfer?.files?.[0]
        if (configFile) {
            setUploadedConfig(configFile)
        }
    }

    const handleSelectedConfigNameChange = (e: ChangeEvent<HTMLInputElement>) =>
        setSelectedConfigName(e.target.value)

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const configFile = e.target.files?.[0]
        if (configFile) {
            setUploadedConfig(configFile)
        }
    }

    const handleSubmit = () => {
        if (uploadedConfig instanceof File) {
            const formData = new FormData()
            formData.append('file', uploadedConfig)
            formData.append('config_key', selectedConfigName)
            console.log('fData>>>', formData)
            dispatch(
                uploadProductConfig({
                    guid,
                    formData,
                    filename: uploadedConfig.name,
                })
            )
        }
        setTimeout(() => handleClose(), 0)
    }

    const isValid = !!uploadedConfig && !!selectedConfigName

    return (
        <>
            <div className="bg-blur" />
            <Modal
                centered
                show={true}
                onHide={handleClose}
            >
                <UploadConfigHeader />
                <Modal.Body className={style.windowPadding}>
                    <UploadConfigDisclaimer />
                    <Form className="pb-2">
                        {configNames.map((configName) => (
                            <Form.Check
                                key={configName}
                                value={configName}
                                id={configName}
                                onChange={handleSelectedConfigNameChange}
                                type="radio"
                                className="mb-2"
                                name="configsNameGroup"
                                label={
                                    <>
                                        <span className="mx-1">
                                            {configName}
                                        </span>
                                        <FontAwesomeIcon icon={faFileInvoice} />
                                    </>
                                }
                            />
                        ))}
                    </Form>
                    <UploadFileDroppable
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onChange={handleChange}
                        isDragging={dragging}
                        file={uploadedConfig}
                    />
                </Modal.Body>
                <UploadConfigFooter
                    onSubmit={handleSubmit}
                    isValid={isValid}
                />
            </Modal>
        </>
    )
}
